import type { ContactTemperature, LifecycleMilestone } from '@chatbot/shared-types';

const MILESTONE_STYLES: Record<LifecycleMilestone, string> = {
  contacted: 'bg-neutral-100 text-neutral-700 dark:bg-neutral-800 dark:text-neutral-300',
  identified: 'bg-primary-50 text-primary-700 dark:bg-primary-900/30 dark:text-primary-300',
  converted: 'bg-success-50 text-success-700 dark:bg-success-900/30 dark:text-success-300',
  fulfilled: 'bg-success-100 text-success-800 dark:bg-success-900/50 dark:text-success-200',
};

/** Etapa del contacto en el embudo del negocio. */
export function MilestoneBadge({
  milestone,
  label,
}: {
  milestone: LifecycleMilestone | null;
  label: string | null;
}) {
  if (!milestone) return null;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${MILESTONE_STYLES[milestone]}`}
      title="Etapa en el embudo. Avanza sola con lo que la persona hace."
    >
      {label ?? milestone}
    </span>
  );
}

const TEMPERATURE_META: Record<ContactTemperature, { label: string; style: string; hint: string }> =
  {
    hot: {
      label: 'Activo',
      style: 'bg-danger-50 text-danger-700 dark:bg-danger-900/30 dark:text-danger-300',
      hint: 'Escribió en los últimos días',
    },
    warm: {
      label: 'Tibio',
      style: 'bg-warning-50 text-warning-700 dark:bg-warning-900/30 dark:text-warning-300',
      hint: 'Escribió dentro del último mes',
    },
    cold: {
      label: 'Inactivo',
      style: 'bg-neutral-100 text-neutral-500 dark:bg-neutral-800 dark:text-neutral-400',
      hint: 'Hace más de un mes que no escribe',
    },
  };

/**
 * Temperatura del contacto.
 *
 * Se calcula desde la recencia — nadie la etiqueta a mano. El `title` explica
 * de dónde sale, para que no se lea como una opinión del sistema.
 */
export function TemperatureBadge({ temperature }: { temperature?: ContactTemperature }) {
  if (!temperature) return null;
  const meta = TEMPERATURE_META[temperature];
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${meta.style}`}
      title={meta.hint}
    >
      {meta.label}
    </span>
  );
}
